import { ChevronLeft } from "lucide-react";
import { isGroupJid } from "../../../lib/sortChats";
import { ChatAvatar } from "./ChatAvatar";
import { formatJidAsPhone } from "./formatPhone";

// 02.7-settings.md §5/paso b -- extraído de WhatsPanel.jsx. Puramente presentacional: recibe
// `chat`/`presences` por props, `onBack` para volver a la lista.
export default function WhatsConversationHeader({ chat, presences, onBack, onOpenProfile }) {
  return (
    <div
      className="whats-conv-header"
      style={{
        height: "60px",
        padding: "0 var(--space-4)",
        borderBottom: "1px solid #d1d7db",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center"
      }}
    >
      <button
        className="whats-back-btn"
        onClick={onBack}
        style={{ padding: "var(--space-1)", marginRight: "var(--space-2)" }}
      >
        <ChevronLeft size={24} />
      </button>
      <div 
        onClick={onOpenProfile} 
        style={{ display: "flex", alignItems: "center", flex: 1, cursor: "pointer" }}
        title="Ver Perfil"
      >
        <div
          className="whats-chat-avatar"
          style={{ width: "36px", height: "36px", borderRadius: isGroupJid(chat.chat_jid) ? "8px" : "50%" }}
        >
          <ChatAvatar
            url={chat.avatar_url}
            name={chat.name}
            jid={chat.chat_jid}
            isGroup={isGroupJid(chat.chat_jid)}
          />
        </div>
        <div className="whats-conv-title" style={{ fontSize: "15px", flex: 1 }}>
          <div
            className="whats-chat-info"
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "var(--space-3)",
            }}
          >
          <h3
            style={{
              margin: 0,
              fontSize: "16px",
              color: "#111",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {chat.name || formatJidAsPhone(chat.chat_jid)}
            </span>
            {chat.chat_jid && (
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  navigator.clipboard.writeText(chat.chat_jid);
                }}
                style={{
                  fontSize: "10px",
                  color: "#667781",
                  backgroundColor: "#f0f2f5",
                  padding: "2px 6px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "normal",
                  flexShrink: 0
                }}
                title="Copiar ID completo"
              >
                ...{String(chat.chat_jid).replace(/@.+$/, '').slice(-4)}
              </span>
            )}
          </h3>
          {(() => {
            const presencesForChat = presences[chat?.chat_jid] || {};
            const presenceList = Object.values(presencesForChat);
            
            const isComposing = presenceList.some(p => p.lastKnownPresence === "composing");
            const isOnline = presenceList.some(p => p.lastKnownPresence === "available");

            let lastSeenText = "";
            if (isComposing) {
              return <span style={{ fontSize: "12px", color: "#25D366", marginTop: "2px", fontWeight: "500", fontStyle: "italic" }}>Escribiendo...</span>;
            }
            if (isOnline) {
              return <span style={{ fontSize: "12px", color: "#25D366", marginTop: "2px", fontWeight: "500" }}>En línea</span>;
            }

            const lastSeenObj = presenceList.find(p => p.lastSeen);
            if (lastSeenObj) {
              const dateObj = new Date(Number(lastSeenObj.lastSeen) * 1000);
              const timeStr = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
              lastSeenText = `Últ. vez a las ${timeStr}`;
            } else if (chat?.last_message_timestamp) {
              const dateObj = new Date(chat.last_message_timestamp);
              const timeStr = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
              const isToday = new Date().toDateString() === dateObj.toDateString();
              if (isToday) {
                lastSeenText = `Últ. vez hoy a las ${timeStr}`;
              } else {
                const dateStr = dateObj.toLocaleDateString([], { day: '2-digit', month: 'short' });
                lastSeenText = `Últ. vez el ${dateStr} a las ${timeStr}`;
              }
            }

            if (lastSeenText) {
              return <span style={{ fontSize: "12px", color: "#667781", marginTop: "2px" }}>{lastSeenText}</span>;
            }

            return null;
          })()}
          </div>
        </div>
      </div>
    </div>
  );
}
